import { NavLink } from "react-router-dom";
import strings from "../lang/Localiz";
import React, { useState } from "react";
import useStore from "../store";
import Sound from "./Sound";
import ExitContainer from "./Exit";
import LangSelector from "./LangSelector";
import logo from "../images/logo.svg";
import HudMain from "./HudMain";

export default function Header() {
  const loggedIn = useStore((state) => state.loggedIn);
  const token = localStorage.getItem("token");
  const [exitApprove, setExitApprove] = useState(false);
  const reduction = new URLSearchParams(window.location.search).get("reduction");
  

  const exit = () => {
    localStorage.removeItem("username");
    localStorage.removeItem("token");
    window.location.reload();
  };

  const dismissPicker = () => {
    if (exitApprove) setExitApprove(false);
  };

  return (
    <header>
      <div className="header-top">
        <div className="logo">
          <img src={logo} alt="" />
        </div>
        <nav>
          {!(loggedIn || token) && (
            <NavLink exact className={"link-menu"} to="/">
              {strings.loginPage}
            </NavLink>
          )}
          {(loggedIn || token) && (
            <NavLink exact className={"link-menu"} to={`/game${window.location.search ? window.location.search : ""}`}>
              {strings.mainPage}
            </NavLink>
          )}
          <NavLink exact className={"link-menu"} to={`/rules${window.location.search ? window.location.search : ""}`}>
            {strings.descriptionPage}
          </NavLink>
        </nav>
        <LangSelector />
        <div className="copyright">{strings.copyright}</div>
        <Sound />
        {!reduction && (loggedIn || token) && (
          <div className={"exit-block"}>
            <div
              onClick={() => setExitApprove(!exitApprove)}
              className={"link-menu"}
            >
              {strings.logout}
            </div>
            {exitApprove && (
              <ExitContainer dismissPicker={() => dismissPicker()} />
            )}
          </div>
        )}
      </div>
      <HudMain />
    </header>
  );
}
